<template>
  <div class="ui-container">
    <h2>Breadcrumb</h2>
    <div class="ui-block">
      <Breadcrumb />
    </div>
  </div>
</template>
